module.exports = __webpack_public_path__ + "static/media/keyFeature3.2024e3d5.png";